import keyMirror from 'keymirror';

export const gameActionTypes = keyMirror({
	GET_GAME_DATA_REQUEST: null,
	GET_GAME_DATA_SUCCESS: null,
	GET_GAME_DATA_ERROR: null,
	FINISH_GAME_REQUEST: null,
	FINISH_GAME_SUCCESS: null,
	FINISH_GAME_ERROR: null,
	CLEAR_GAME_STATE: null,
	SET_CURRENT_LEVEL: null,
});

export const GAME_TYPES = {
	BOUNCY_SUMS_GAME: 'BouncySumsGame',
	LANE_CHOOSER_GAME: 'CanoeGame',
	LETTER_PARTY_GAME: 'LetterpartyGame',
	MEASUREMENT_GAME: 'MeasurementGame',
	TIME_GAME: 'TimeGame',
	TRACING_GAME: 'TracingGame',
} as const;

export enum JuniorGameType {
	LETTER_PARTY = 'letter_party_game',
	TRACING = 'tracing_game',
}
